import React, { useCallback, useContext } from 'react';

import { BodyMeasurementsContext } from '../../body-measurements.context';
import DialogBodyMeasurement from '../Form/DialogBodyMeasurement';

export default function EditDialog() {
  const { editDialogOpened, setEditDialogOpened, selectedData, reload } = useContext(BodyMeasurementsContext);
  const closeDialog = useCallback(
    (success: boolean) => {
      if (success) {
        reload();
      }
      setEditDialogOpened(false);
    },
    [reload, setEditDialogOpened]
  );

  return <DialogBodyMeasurement open={editDialogOpened} onClose={closeDialog} data={selectedData} />;
}
